module.exports = __webpack_public_path__ + "fd5f30ea774cb8ae0f2f9fa0408c9369.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/incer.png
// module id = 605
// module chunks = 0